import axios from '../axios/axios-api'

async function actualizarPedido (code, id, estadoEncargado) {
  const pedidoActualizado = await axios.get(`api/pedido/cambiarEstado/${estadoEncargado}/${id}`)
  return pedidoActualizado.data
}

export default actualizarPedido
